/** Routes where the customer bottom nav already appears today. */
export function shouldShowCustomerFooter(pathname) {
  const path = String(pathname || "").toLowerCase();
  if (!path || path.startsWith("/delivery")) return false;

  if (path === "/" || path === "/relax" || path === "/phase2") return true;
  if (path.startsWith("/cart")) return true;
  if (
    path === "/my-wishlist" ||
    path.startsWith("/my-wishlist") ||
    path.includes("/wishlist") ||
    path.includes("/my-favorite")
  ) {
    return true;
  }
  if (path.includes("/my-account") || path.includes("/edit-profile")) return true;
  if (path.includes("/my-orders") || path.includes("/my-addresses") || path.includes("/alerts")) return true;
  if (path.includes("/customer-support")) return true;
  if (path.includes("/categories") || path.includes("/explore")) return true;
  if (path.startsWith("/relax/brands") || path.startsWith("/relax/brand/")) return true;
  if (path.startsWith("/relax/browse") || path.startsWith("/relax/products") || path.startsWith("/relax/category")) return true;
  if (path.includes("/order-confirmed") || path.includes("/payment-done") || path.includes("/running-order")) return true;
  if (path.includes("/try-session")) return true;
  if (path.startsWith("/best-selling-items") || path.startsWith("/content-screen")) return true;
  return false;
}

/** Delivery tab screens that currently mount DeliveryBottomNav. */
export function shouldShowDeliveryFooter(pathname) {
  const path = String(pathname || "");
  return (
    path === "/delivery/home" ||
    path === "/delivery/orders" ||
    path === "/delivery/map" ||
    path === "/delivery/earnings" ||
    path === "/delivery/profile" ||
    path === "/delivery/me"
  );
}
